import { render, staticRenderFns } from "./BusinessApps.vue?vue&type=template&id=1f641870&scoped=true"
import script from "./BusinessApps.vue?vue&type=script&lang=js"
export * from "./BusinessApps.vue?vue&type=script&lang=js"
import style0 from "./BusinessApps.vue?vue&type=style&index=0&id=1f641870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f641870",
  null
  
)

export default component.exports